namespace $ {
	$.$hyoo_crus_yard.masters = [
		//'https://crus.hd4.ru/', // switched to giper baza
		'https://i-love-crus.ru/', // amigun
		//'https://crus.xedth.ru/', zubkov_p, unsupported
		'https://crus.87-120-36-150.ip.hyoo.ru/', // Dev_Cmyser
		'https://crus1.ocas.ai/', // webmalex
	]
}
